module.exports = __webpack_public_path__ + "assets/img/en-f9e5f8c3.png";